<template>
  <div class="full-block-video" :class="{'search-results': showSearchResults, 'half-page': isHalfPageGrid} ">
    <div  v-if="fileFormat==='svg'">
      <object ref="svgObject" :data="source" type="image/svg+xml"></object>
      <div class="click-overlay" :style="videoRegion" @click.stop="handleClick"></div>
   </div>
    <video v-else ref="video" :autoplay="isAutoplay"  @ended="handleDelay" :poster="posterSource" @click.stop="handleClick" muted playsinline>
      <source :src="source" type="video/mp4" />
      <source :src="source" type="video/webm" />
    </video>
    <div class="buttons_set custom_controls" v-if="isMobileAndTablet ? mobileControls  : showControls" :style="inverseScaling">
      <img :src="playBtnIcon" tabindex="0" @click="toggleVideoPlay" alt="" :style="inverseImgScaling">
      <img v-if="hasAudio" :src="muteBtnIcon" tabindex="0" @click="toggleVideoMute"
           alt="" :style="inverseImgScaling">
      <img class="closeBtn" src="/icons/in-block-video/close.svg" tabindex="0"
           @click="closeInBlockVideo" alt="close" :style="inverseImgScaling">
    </div>
  </div>
</template>
<script>
import featureMixin from "@/mixins/featureMixin";
import blockElementMixin from "@/mixins/blockElementMixin";
import InblockVideosMixin from "@/features/inblock-videos/InblockVideosMixin";
import {mapGetters} from "vuex";
export default {
  mixins: [featureMixin, blockElementMixin,InblockVideosMixin],
  data() {
    return {
      videoPlaying: true,
      videoMuted: true,
      featurePath: 'blockVideos.fullBlock'
    }
  },
  props: {
    posterSource: String,
  },
  mounted() {
    const v = this.$refs.video;
    v.play()
    // Hide Picture-In-Picture on hover in MS Edge
    if(window.navigator.userAgent.indexOf("Edg")> -1){
      v.setAttribute('disablePictureInPicture', true);
      v.setAttribute('controlsList','nodownload')
    }
    this.$emit('fVideoStarted')
  },
  computed: {
    ...mapGetters('screen', [ 'isMobileAndTablet']),
    ...mapGetters(['isCTC', 'isJC', 'isHalfPageGrid']),
    ...mapGetters('search', ['showSearchResults']),
   },
  beforeDestroy() {
    const video = this.$refs.video;
    video.removeEventListener('play', this.onVideoEvent)
  },
  methods: {
    play() {
      this.$refs.video.play();
    },
    pause() {
      this.$refs.video.pause();
    },
    onVideoEvent() {
      const video = this.$refs.video;
      this.videoPlaying = !video.paused;
    },
    toggleVideoPlay() {
      const isPlaying = !this.$refs.video.paused;
      this.videoPlaying = !isPlaying;
      if (isPlaying) {
        this.pause();
      }
      else
        this.play();
    },
   
    toggleVideoMute() {
      const video = this.$refs.video;
      this.videoMuted = !video.muted;
      video.muted = !video.muted;
      /*let vid = document.getElementById(`${this.id}`);
            !this.videoMuted ?  vid.muted=true : vid.muted=false*/
    },
    closeInBlockVideo() {
      this.$emit('handleUserClose')
    },
    handleDelay() {
        this.$emit('videoClosed')
    },
  }
}
</script>
<style lang="scss" scoped>
.full-block-video {
  position: relative;
  height: 100%;
  >.buttons_set {
    bottom: 2px;
    width: 100% !important;
    z-index: 1005;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    height: 7%;
    padding: 0 10px;
    background: rgba(0, 0, 0, 0.5);
    transition: opacity 300ms;
    //transition-delay: 2s;
    opacity: 0;
    font-size: 16px;
    //&:hover{
    //  transition-delay: unset;
    //  opacity: 1;
    //}
    img {
      max-height: 70%;
      height: auto;
    }
  }
  >.buttons_set.custom_controls {
    height: 44px !important;
    img {
      width: auto;
      height: auto
    }
  }
  .buttons_set.buttons_set.customMetro {
    display: none;
  }
  &:hover>.buttons_set {
    transition-delay: unset;
    opacity: 1;
  }
  .buttons_set img {
    cursor: pointer;
    left: 10%;
    margin-left: 10px;
    pointer-events: all;
  }
  .buttons_set.customMetro img {
    margin-left: 16px;
    pointer-events: all;
  }
  .closeBtn {
    border-radius: 50px;
    // background-color: red;\
    margin-right: 10px;
    border: none;
    margin-left: auto !important;
    right: 5% !important
  }
  video {
    width: 100.1%;
    height: 100.1%;
    background: transparent;
    object-fit: cover !important;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
    z-index: 10;
  }
}
.full-block-video.pop-video {
  &:hover,
  &:focus {
    transform: scale(1.02);
    box-shadow: 0 0 50px rgba(0, 0, 0, 0.3);
    z-index: 9999;
    outline: none;
  }
}

.full-block-video.search-results {
  position: relative;
  height: 100%;
  >.buttons_set {
    bottom: 2px;
    left: 0;
    width: 100% !important;
    box-sizing: border-box;
    z-index: 1005;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    height: 7%;
    padding: 0 10px;
    background: rgba(0, 0, 0, 0.5);
    transition: opacity 300ms;
    opacity: 0;
    font-size: 16px;
    transform: none !important;
    img {
      transform: none !important;
      min-height: unset !important;
      max-height: 70% !important;
      height: auto !important;
    }
  }
  >.buttons_set.custom_controls {
    height: 44px !important;
    img {
      width: auto !important;
      height: auto !important;
    }
  }
  .buttons_set.buttons_set.customMetro {
    display: none;
  }
  &:hover>.buttons_set {
    transition-delay: unset;
    opacity: 1;
  }
  .buttons_set img {
    cursor: pointer;
    left: 10%;
    margin-left: 10px;
    pointer-events: all;
  }
  .buttons_set.customMetro img {
    margin-left: 16px;
    pointer-events: all;
  }
  .closeBtn {
    border-radius: 50px;
    // background-color: red;\
    margin-right: 10px;
    border: none;
    margin-left: auto !important;
    right: 5% !important
  }
  video {
    width: 100.1%;
    height: 100.1%;
    background: transparent;
    object-fit: cover !important;
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
    z-index: 10;
  }
 }
 
.full-block-video.search-results.half-page {
   position: absolute;
   video {
    width: unset;
   }
}
</style>